import {ISonicUserInfo} from '../components/Interface/IMsalAuth'

export const RemediationUsers: Array<ISonicUserInfo> = [
    { name: "Jinping Zheng", userName: "v-jinzhe@microsoft.com" },
    { name: "Ying Huang", userName: "v-yinghuang@microsoft.com" },
    { name: "Dale Chen", userName: "daleche@microsoft.com" },
    { name: "William Chen", userName: "willchen@microsoft.com" },
    { name: "Ray Ringhiser", userName: "rayring@microsoft.com" },
    { name: "Dalton Young (HE, HIM)", userName: "dyoung@microsoft.com" },
    { name: "Ana Baratz", userName: "anabaratz@microsoft.com" },
    { name: "Jose Soriano", userName: "josorian@microsoft.com" },
    { name: "Phil Johnson", userName: "philjohn@microsoft.com" },
    { name: "Tony Cheung", userName: "tcheung@microsoft.com" },
    { name: "Yoshiko Morita (SHE/HER)", userName: "yoshmor@microsoft.com" },
    { name: "Mingyu Tan", userName: "v-mingyutan@microsoft.com" },
    { name: "Emily Ye", userName: "v-emy@microsoft.com" },
    { name: "Chunhui Zhang", userName: "v-chunzhang@microsoft.com" },
    { name: "Jade Wang", userName: "v-wangja@microsoft.com" },
    { name: "Wenlong Li", userName: "v-wenlongli@microsoft.com" },
    { name: "Lingli Xiong", userName: "v-lixiong@microsoft.com" },
    { name: "Daisy Wu", userName: "v-danwu@microsoft.com" },
    { name: "Emma Pei", userName: "v-shpei@microsoft.com" },
    { name: "Thomas Lin", userName: "genli@microsoft.com" },
    { name: "Christy Su", userName: "christys@microsoft.com" },
    { name: "Haiying Yu", userName: "haiyingyu@microsoft.com" },
    { name: "Meera Krishna", userName: "meerak@microsoft.com" },
    { name: "Deland Han", userName: "delhan@microsoft.com" },
    { name: "Lu Chen", userName: "luche@microsoft.com" },
    { name: "Hui Chen", userName: "v-huichen1@microsoft.com" },
    { name: "Kaushik Ainapure", userName: "kaushika@microsoft.com" },
    { name: "MingLiang Xiao", userName: "v-minglxiao@microsoft.com" },
    { name: "Simonx Xu", userName: "v-six@microsoft.com" }
];